module.exports = __webpack_public_path__ + "img/haijunlan2.19615ccd.png";